import cn from 'classnames';

import { Props } from '../model';

import { Icon } from '@/features/icon/ui';

import cls from './styles.module.pcss';


export function IconButton({ name, text, className, ...attrs }: Props) {
  return (
    <button className={cn(className, cls.IconButton, { [cls.WithText]: text })} {...attrs}>
      <Icon name={name} />
      {text && <span>{text}</span>}
    </button>
  )
}
